import dvaModelExtend from 'dva-model-extend';
import _ from 'lodash';

import { bindServices } from '@/services/api';
import { createCrudModel } from '@/utils/core/dva';
import { CoreEnums } from '@/utils/domain/constants';
import { getFiltersGlobalFilters, toPaginate } from '@/utils/infrastructure';
import CoreQueries from '@/utils/input/queries';

import { ENTITY_NAME, FETCH_ROUTE, MODEL_NAME } from './constants';

const api = bindServices(MODEL_NAME);
const { BulkActionType } = CoreEnums;

const namespace = MODEL_NAME;
const fetchRoute = FETCH_ROUTE;
const fetchParams = FETCH_ROUTE;

const _model = createCrudModel({
  namespace,
  fetchRoute,
  fetchParams,
  entityName: ENTITY_NAME,
  api,
  features: { import: false, bulkActions: false },
  state: {
    showImport: false,
    importError: false,
    errorMessage: '',
    errors: [],
  },
  effects: {
    *bulkDeleteConnectionGroups({ payload }, { call, put, select }) {
      try {
        const { ids } = payload;
        if (!ids || ids.length === 0) return;
        yield call(api.bulkAction, {
          route: fetchRoute,
          bulkActionType: BulkActionType.Delete,
          ids,
        });

        const pageSize = yield select((state) => state.global.pageSize);
        const stateData = yield select((state) => state[namespace]);
        const globalState = yield select((state) => state.global);
        const filters = getFiltersGlobalFilters(globalState.globalFilters, namespace);
        const params = {
          ...CoreQueries[fetchParams].paged,
          page: 1,
          limit: pageSize,
          ...(globalState.searchCriteria && { search: globalState.searchCriteria }),
          ...(stateData.orderBy && { orderBy: stateData.orderBy }),
          ...(filters && { filter: filters }),
          select: stateData.select,
          ...(stateData.searchSelect && { searchSelect: stateData.searchSelect }),
        };

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: { visible: true, type: 'success' },
        });
        yield put({ type: 'fetchList', payload: params });
      } catch (error) {
        if (error?.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: { visible: true, type: 'error', message: error.message },
          });
        }
      }
    },

    *toggleImportComponent({ payload }, { put }) {
      yield put({
        type: 'queryToggleImportComponent',
        payload: { showImport: payload.show },
      });
    },

    *fetchImport({ payload }, { call, put, select }) {
      try {
        const { file, isDeleteData } = payload;
        const pageSize = yield select((state) => state.global.pageSize);
        const stateData = yield select((state) => state[namespace]);
        const globalState = yield select((state) => state.global);
        const filters = getFiltersGlobalFilters(globalState.globalFilters, namespace);
        const params = {
          ...CoreQueries[fetchParams].paged,
          page: 1,
          limit: pageSize,
          ...(globalState.searchCriteria && { search: globalState.searchCriteria }),
          ...(stateData.orderBy && { orderBy: stateData.orderBy }),
          ...(filters && { filter: filters }),
          ...(stateData.searchSelect && { searchSelect: stateData.searchSelect }),
        };

        const res = yield call(api.apiRoute, {
          route: `${fetchRoute}/import`,
          method: 'post',
          data: { fileContent: file, deleteExistingData: isDeleteData },
        });

        if (res.errorMessage) {
          yield put({ type: 'queryImportErrors', payload: { ...res } });
        } else {
          yield put({ type: 'queryImport', payload: { ...res } });
          yield put({ type: 'fetchList', payload: params });
        }
      } catch (error) {
        if (error?.message) {
          yield put({
            type: 'global/showNotificationsGlobal',
            payload: { visible: true, type: 'error', message: error.message },
          });
        }
      }
    },

    *clearImportErrors(_, { put }) {
      yield put({ type: 'clearImportErrors' });
    },
  },
  reducers: {
    queryData(state, { payload }) {
      return {
        ...state,
        list: payload.items || [],
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    queryToggleImportComponent(state, { payload }) {
      return {
        ...state,
        showImport: payload.showImport ?? payload.show,
      };
    },

    queryImport(state) {
      return {
        ...state,
        showImport: false,
        importError: false,
        errorMessage: null,
        errors: null,
      };
    },

    queryImportErrors(state, { payload }) {
      return {
        ...state,
        importError: true,
        errorMessage: payload.errorMessage,
        errors: payload.errors || [],
      };
    },

    clearImportErrors(state) {
      return {
        ...state,
        errorMessage: null,
        errors: null,
        importError: false,
      };
    },
  },
});

export default dvaModelExtend(_model, { namespace });
